// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
var _ = require('lodash');
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import {
  unloadDashboard, searchSuggestions, navActivate,
  selectIndex, showUtilization
} from '../../actions/actions';
import {
  loadTwigs, changeDisplayOption, changeDepthOption, showTrendLine, showRawGraph,
  changeTrendAverage, showUpperLimit, showLowerLimit, changeZoomOption
} from '../../actions/locationView';
import constants from '../../Constants';

import Article from 'grommet/components/Article';
import Header from 'grommet/components/Header';
import Headline from 'grommet/components/Headline';
import Section from 'grommet/components/Section';
import Search from 'grommet/components/Search';
import Title from 'grommet/components/Title';
import Tile from 'grommet/components/Tile';
import Box from 'grommet/components/Box';
import FormField from 'grommet/components/FormField';
import DateTime from 'grommet/components/DateTime';
import Form from 'grommet/components/Form';
// import Label from 'grommet/components/Label';
import Value from 'grommet/components/Value';
import Select from 'grommet/components/Select';
import Button from 'grommet/components/Button';
import Sidebar from 'grommet/components/Sidebar';
import Split from 'grommet/components/Split';
import CheckBox from 'grommet/components/CheckBox';
import CaretBackIcon from 'grommet/components/icons/base/CaretBack';
import Heading from 'grommet/components/Heading';
import RadioButton from 'grommet/components/RadioButton';

import NavControl from '../NavControl';
// import  from 'grommet/components/Base';
// import Chart, { Layers, Base, Axis, Grid, Area, Bar, Line, Marker, MarkerLabel, HotSpots } from 'grommet/components/chart/Chart';



import { navEnable } from '../../actions/nav';



class LocationView extends Component {

  constructor(props) {
    super(props);
    this._changeDisplayOption = this._changeDisplayOption.bind(this);
    this._changeDepthOption = this._changeDepthOption.bind(this);
    this._trendOptionChange = this._trendOptionChange.bind(this);
    this._averageTrendChange = this._averageTrendChange.bind(this);
    this._changeLimitOption = this._changeLimitOption.bind(this);
    this.state = {
      trendOption: constants.TREND_OPTIONS.BOTH,
      rawSelected: true,
      trendSelected: true
    }
  }

  componentWillMount() {
  }


  componentDidMount() {

  }
  componentDidUpdate() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {
    // this.props.dispatch(unloadDashboard());
    // this._graphicSizer.stop();
  }
  _changeZoomOption(event) {
    let value = event.target.checked;
    setTimeout(() => {
      this.props.dispatch(changeZoomOption(value));
    }, 10)
  }

  _changeDepthOption(key, event) {
    let payload = {
      key: key,
      value: event.target.checked
    }
    setTimeout(() => {
      this.props.dispatch(changeDepthOption(payload));
    }, 10)
  }

  _changeDisplayOption(key, event) {
    let payload = {
      key: key,
      value: event.target.checked
    }
    setTimeout(() => {
      this.props.dispatch(changeDisplayOption(payload));
    }, 10)
  }

  _changeLimitOption(type, event) {
    let value = event.target.checked;

    if (type == constants.CHART_LIMIT.TOP) {
      setTimeout(() => {
        this.props.dispatch(showUpperLimit(value));
      }, 10)
    } else if (type == constants.CHART_LIMIT.LOWER) {
      setTimeout(() => {
        this.props.dispatch(showLowerLimit(value));
      }, 10)
    }
  }
  _trendOptionChange(type, event) {
    let value = event.target.checked;
    let callAction = false;
    if (type == constants.TREND_OPTIONS.RAW && this.props.showTrendLine) {
      this.setState({
        rawSelected: value
      })
      callAction = true;
    } else if (type == constants.TREND_OPTIONS.TRENDLINE && this.props.showRawGraph) {
      this.setState({
        trendSelected: value
      })
      callAction = true;
    }
    if (callAction) {
      setTimeout(() => {
        if (type == constants.TREND_OPTIONS.RAW) {
          this.props.dispatch(showRawGraph(value));
        } else {
          this.props.dispatch(showTrendLine(value));
        }
      }, 10)
    }
  }
  _averageTrendChange(event) {
    let avgTrendValue = event.target.value;
    setTimeout(() => {
      this.props.dispatch(changeTrendAverage(avgTrendValue));
    }, 10)
  }

  renderTwigCheckboxes() {
    let twigCheckBoxes = [];
    if (this.props.selectedTwig && this.props.selectedTwig.details && this.props.selectedTwig.details.data) {
      twigCheckBoxes.push(
        <FormField key='zoom'>
          <CheckBox label='Zoom'
            checked={this.props.zoom}
            toggle={false}
            disabled={false}
            onChange={this._changeZoomOption.bind(this)}
            reverse={false} />
        </FormField>
      )
      let allObjects = Object.entries(this.props.selectedTwig.details.data);
      const filterObjects = allObjects.sort((a, b) => a[1].sort_order - b[1].sort_order).filter(each => (each[1].sort_order !== 1 && each[1].sort_order !== 6));
      filterObjects.map((item, index) => {
        let displayOptions = {};
        let isChecked = false;
        if (this.props.chartOptions) {
          if (this.props.chartOptions.DisplayOptions) {
            displayOptions = this.props.chartOptions.DisplayOptions
          } else if (this.props.chartOptions.displayOptions) {
            displayOptions = this.props.chartOptions.displayOptions
          }
        }
        
        if (Object.keys(displayOptions).length > 0) {
          isChecked = displayOptions[item[0]];
        }

        twigCheckBoxes.push(
          <FormField key={index}>
            <CheckBox label={item[1].label}
              checked={isChecked}
              toggle={false}
              disabled={false}
              onChange={this._changeDisplayOption.bind(this, item[0])}
              reverse={false} />
          </FormField>
        )
      })
    }
    return twigCheckBoxes
  }



  render() {
    let optionStyle = {
      color: 'black'
    }
    let averageDropDown = {
      display: this.props.trendOption == constants.TREND_OPTIONS.RAW ? 'none' : 'block'
    }
    let top = this.props.chartOptions.depth[constants.CHART_OPTIONS.TOP];
    let middle = this.props.chartOptions.depth[constants.CHART_OPTIONS.MIDDLE]

    return (
      <div>
        <Button label='Back'
          icon={<CaretBackIcon />}
          path="/site"
          plain={true} />
        {/*<Header pad='medium'
            justify='between'>
            <Title>
              Location View
            </Title>
          </Header>*/}
        <Box flex='grow'
          justify='start'>

          <Form>
            <Header pad={{ horizontal: 'medium' }}>
              <label>DISPLAY OPTIONS</label>
            </Header>
            {
              this.renderTwigCheckboxes()
            }
          </Form>

          <Form>
            <Header pad={{ horizontal: 'medium' }}>
              <label>DEPTH</label>
            </Header>
            <FormField>
              <CheckBox label='Top'
                checked={this.props.chartOptions.depth[constants.CHART_OPTIONS.TOP]}
                onChange={this._changeDepthOption.bind(this, constants.CHART_OPTIONS.TOP)}
                toggle={false}
                disabled={false}
                reverse={false} />
            </FormField>
            <FormField>
              <CheckBox label='Middle'
                checked={this.props.chartOptions.depth[constants.CHART_OPTIONS.MIDDLE]}
                onChange={this._changeDepthOption.bind(this, constants.CHART_OPTIONS.MIDDLE)}
                toggle={false}
                disabled={false}
                reverse={false} />
            </FormField>
            <FormField>
              <CheckBox label='Bottom'
                checked={this.props.chartOptions.depth[constants.CHART_OPTIONS.BOTTOM]}
                onChange={this._changeDepthOption.bind(this, constants.CHART_OPTIONS.BOTTOM)}
                toggle={false}
                disabled={false}
                reverse={false} />
            </FormField>
          </Form>

          <Form>
            <Header pad={{ horizontal: 'medium' }}>
              <label>DATA MODEL</label>
            </Header>

            <FormField>
              <CheckBox label='Raw'
                checked={this.props.showRawGraph}
                onChange={this._trendOptionChange.bind(this, constants.TREND_OPTIONS.RAW)}
                toggle={false}
                disabled={false}
                reverse={false} />
            </FormField>
            <FormField>
              <CheckBox label='Trend' key={1}
                checked={this.props.showTrendLine}
                onChange={this._trendOptionChange.bind(this, constants.TREND_OPTIONS.TRENDLINE)}
                toggle={false}
                disabled={false}
                reverse={false} />
              <select style={averageDropDown} onChange={this._averageTrendChange} key={2}
                disabled={!this.props.showTrendLine} value={this.props.trendAverage}>
                <option style={optionStyle} value="5" key={5}>SMA5</option>
                <option style={optionStyle} value="10" key={10}>SMA10</option>
                <option style={optionStyle} value="20" key={20}>SMA20</option>
              </select>
            </FormField>
          </Form>

          {/* <Form>
            <Header pad={{ horizontal: 'medium' }}>
              <label>LIMITS</label>
            </Header>
            <FormField>
              <CheckBox label='Upper'
                toggle={false}
                checked={this.props.showUpperLimit}
                onChange={this._changeLimitOption.bind(this, constants.CHART_LIMIT.TOP)}
                disabled={false}
                reverse={false} />
            </FormField>
            <FormField>
              <CheckBox label='Lower'
                toggle={false}
                checked={this.props.showLowerLimit}
                onChange={this._changeLimitOption.bind(this, constants.CHART_LIMIT.LOWER)}
                disabled={false}
                reverse={false} />
            </FormField>
          </Form> */}
        </Box>
      </div>

    );
  }

}

LocationView.propTypes = {
  twigsList: PropTypes.array,
  search: PropTypes.object
};

let select = (state, props) => ({
  selectedTwig: state.locationView.selectedTwig,
  showRawGraph: state.locationView.showRawGraph,
  showTrendLine: state.locationView.showTrendLine,
  trendAverage: state.locationView.trendAverage,
  // chartData: state.locationView.chartData,
  // search: state.search
  showLowerLimit: state.locationView.showLowerLimit,
  showUpperLimit: state.locationView.showUpperLimit,
  chartOptions: state.locationView.chartOptions,
  zoom:state.locationView.zoom
});

export default connect(select)(LocationView);



// WEBPACK FOOTER //
// ./src/js/components/location/SideMenu.js